"use client"

import { Alert, AlertDescription } from "@/components/ui/alert"
import { MailWarning } from "lucide-react"
import { ResendVerification } from "./resend-verification"

/**
 * Persistent banner shown to a paid signup whose email is still unverified.
 * Auto-login is granted for paid intent so the user can finish checkout, but
 * login/refresh enforce verification server-side — leaving the access token to
 * expire within ~a day. This banner warns the user before that happens and
 * offers a one-click resend.
 */
export function VerifyEmailBanner({ email }: { email: string }) {
  return (
    <Alert className="rounded-none border-x-0 border-t-0 bg-orange-50 border-orange-200">
      <MailWarning className="h-4 w-4 text-orange-600" />
      <AlertDescription className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
        <span className="text-orange-800">
          Please verify your email to keep access to your account. Your session will end soon if it
          stays unverified.
        </span>
        <ResendVerification email={email} showInput={false} size="sm" className="w-full sm:w-56 shrink-0" />
      </AlertDescription>
    </Alert>
  )
}
